<template>
  <div>
    <b-row class="mb-2 justify-content-between align-items-center">
      <b-col>
        <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
      </b-col>
      <b-col class="text-right">
        <b-button variant="primary" @click="saveLoan">
          <feather-icon icon="SaveIcon" class="mr-1" /> Guardar Préstamo
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="loan">
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información del Préstamo</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="2">
                <strong>Establecimiento Origen:</strong>
                <p>{{ loan.establishmentOrigin.name }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Cliente:</strong>
                <p>{{ loan.client.fullname }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Documento:</strong>
                <p>{{ loan.documentCode }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Estado:</strong>
                <p>{{ loan.state }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Fecha Límite:</strong>
                <p>{{ formatDate(loan.limitDate) }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Fecha Inicial:</strong>
                <p>{{ formatDate(loan.created_at) }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles del Préstamo</h4>
          </b-card-header>
          <b-card-body>
            <b-table
              :items="loanDetails"
              :fields="fields"
              responsive
              hover
              show-empty
              empty-text="No existen detalles"
            >
              <template #cell(state)="data">
                <span :class="getStateClass(data.item.state)">
                  {{ data.item.state }}
                </span>
              </template>

              <template #cell(actions)="data">
                <b-button v-if="data.item.state == 'Pendiente'"
                  size="sm"
                  v-b-tooltip.hover
                  title="Devolver"
                  variant="danger"
                  @click="returnItem(data.item)"
                >
                  <feather-icon icon="RefreshCcwIcon" />
                </b-button>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showReturnModal"
      title="Devolver artículo"
      @hide="resetReturnForm"
      hide-footer
      dialog-class="modal-dialog-centered"
    >
      <b-form @submit.prevent="confirmReturn">
        <b-form-group label="Cantidad a devolver" label-for="returnQty">
          <b-form-input
            id="returnQty"
            v-model.number="returnForm.qty"
            type="number"
            :max="returnForm.maxQty"
            :min="1"
            required
          ></b-form-input>
          <b-form-invalid-feedback v-if="returnForm.qty > returnForm.maxQty">
            ⚠️ El valor debe ser menor o igual a {{ returnForm.maxQty }}.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Observación" label-for="returnObservation">
          <b-form-textarea
            id="returnObservation"
            v-model="returnForm.observation"
            rows="3"
            required
          ></b-form-textarea>
          <b-form-invalid-feedback v-if="!returnForm.observation">
            ⚠️ La observación es obligatoria.
          </b-form-invalid-feedback>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button type="submit" variant="primary">Enviar</b-button>
          <b-button
            variant="secondary"
            class="ml-2"
            @click="showReturnModal = false"
          >
            Cancelar
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Modal para Guardado Completo -->
    <b-modal
      v-model="showInvoiceModal"
      title="Información de Factura"
      @hide="resetInvoiceForm"
      hide-footer
      dialog-class="modal-dialog-centered"
    >
      <b-form @submit.prevent="confirmInvoice">
        <b-form-group label="Vendedor" label-for="sellerSelect">
          <v-select
            id="sellerSelect"
            v-model="invoiceForm.sellerId"
            :options="sellerOptions"
            :reduce="option => option.value"
            placeholder="Buscar vendedor"
            label="text"
            :filterable="true"
            :searchable="true"
          >
          </v-select>
          <b-form-invalid-feedback v-if="!invoiceForm.sellerId">
            ⚠️ Debe seleccionar un vendedor.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Número de Factura" label-for="billNumber">
          <b-form-input
            id="billNumber"
            v-model="invoiceForm.billNumber"
            type="text"
            placeholder="Ingrese el número de factura"
            required
          ></b-form-input>
          <b-form-invalid-feedback v-if="!invoiceForm.billNumber">
            ⚠️ El número de factura es obligatorio.
          </b-form-invalid-feedback>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button type="submit" variant="primary">Confirmar</b-button>
          <b-button
            variant="secondary"
            class="ml-2"
            @click="showInvoiceModal = false"
          >
            Cancelar
          </b-button>
        </div>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import vSelect from 'vue-select'
import Ripple from "vue-ripple-directive";
import LoanService from "@/services/LoanService";
import UserService from '@/services/UserService'
import * as XLSX from "xlsx";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    vSelect,
  },
  data() {
    return {
      loan: null,
      loanDetails: [],
      clients: [],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único", sortable: true },
        { key: "autopart.originalCode", label: "Código Original", sortable: true },
        { key: "autopart.alterCode", label: "Código Alterno", sortable: true },
        { key: "autopart.description", label: "Descripción", sortable: false },
        { key: "qty", label: "Cantidad", sortable: false },
        { key: "unitPrice", label: "Precio Unitario", sortable: false },
        { key: "state", label: "Estado", sortable: false },
        { key: "observation", label: "Observación", sortable: false },
        { key: "actions", label: "Acciones", sortable: false },
      ],
      showReturnModal: false,
      showInvoiceModal: false,
      returnForm: {
        qty: 1,
        observation: "",
        maxQty: 0,
        item: null,
      },
      invoiceForm: {
        sellerId: null,
        billNumber: "",
      },
    };
  },
  mounted() {
    this.getLoanDetails();
    this.getClients();
  },
  methods: {
    async getClients() {
      const resp = await UserService.getUsers("", this.$store);
      if (resp) {
        this.clients = resp.data.rows.filter((user) => user.role.name === "Vendedor");
      }
    },
    filterSellers(option, search) {
      const normalizedSearch = search.toLowerCase();
      const normalizedOption = option.text.toLowerCase();
      return normalizedOption.includes(normalizedSearch);
    },
    getStateClass(state) {
      switch (state) {
        case "Pendiente":
          return "badge badge-warning";
        case "Facturado":
          return "badge badge-success";
        case "Devuelto":
          return "badge badge-danger";
        default:
          return "badge badge-secondary";
      }
    },
    formatDate(date) {
      if (!date) return "Sin fecha";
      return date.split("T")[0];
    },
    async getLoanDetails() {
      try {
        const response = await LoanService.getLoanById(this.$route.params.id, this.$store);
        if (response && response.data) {
          this.loan = response.data.loan;
          this.loanDetails = response.data.loanDetails;
        } else {
          this.$swal("Error", "No se encontraron detalles del préstamo.", "error");
        }
      } catch (error) {
        console.error("Error al obtener el préstamo:", error);
        this.$swal("Error", "Ocurrió un problema al cargar los detalles del préstamo.", "error");
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        this.$swal("Error", "Por favor, selecciona un archivo.", "error");
        return;
      }

      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        this.processInvoiceData(jsonData);
      };
      reader.readAsBinaryString(file);
    },
    processInvoiceData(data) {
      if (!Array.isArray(data) || data.length === 0) {
        this.$swal("Error", "El archivo no contiene datos válidos.", "error");
        return;
      }

      let isValid = true;
      let matchCount = 0;

      data.forEach((row) => {
        if (!row["COD PRODUCTO"] || !row["CANTIDAD"]) {
          isValid = false;
        }
      });

      if (!isValid) {
        this.$swal("Error", "El archivo debe contener las columnas 'COD PRODUCTO' y 'CANTIDAD'.", "error");
        return;
      }

      data.forEach((row) => {
        const item = this.loanDetails.find(
          (detail) =>
            detail.autopart.originalCode === row["COD PRODUCTO"] &&
            detail.qty === row["CANTIDAD"] 
        );

        if (item) {
          item.state = "Facturado"; 
          matchCount++;
        }
      });

      if (matchCount > 0) {
        this.$swal(
          "Éxito",
          `${matchCount} producto(s) coincidieron exactamente.`,
          "success"
        );
      } else {
        this.$swal("Aviso", "No se encontraron coincidencias exactas en los productos.", "info");
      }
    },

    async saveLoan() {
      const allItemsReturned = this.loanDetails.every(item => item.state === "Devuelto");

      if (allItemsReturned) {
        this.$swal({
          title: "Advertencia",
          text: "Todas las autopartes están en estado 'Devuelto'. No se puede guardar el préstamo. Por favor, gestione el préstamo desde el listado.",
          icon: "warning",
          confirmButtonText: "Entendido",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary"
          }
        });
        return; 
      }

      //const allItemsProcessed = this.loanDetails.every(item => item.state !== "Pendiente");
      //if (allItemsProcessed) {
      //  this.showInvoiceModal = true;
      //  return;
      //}

      try {
        const payload = {
          documentCode: this.loan.documentCode,
          establishmentOriginId: this.loan.establishmentOriginId,
          clientId: this.loan.clientId,
          autoparts: this.loanDetails,
        };
        await LoanService.updateLoan(this.$route.params.id, payload, this.$store);
        this.$swal("Éxito", "El préstamo ha sido guardado correctamente.", "success");
        this.$router.push("/prestamo");
      } catch (error) {
        console.error("Error al guardar el préstamo:", error);
        this.$swal("Error", "Ocurrió un problema al guardar el préstamo.", "error");
      }
    },
    confirmInvoice() {
      if (!this.invoiceForm.sellerId || !this.invoiceForm.billNumber) {
        this.$swal("Error", "Debe completar todos los campos.", "error");
        return;
      }

      try {
        const payload = {
          documentCode: this.loan.documentCode,
          establishmentOriginId: this.loan.establishmentOriginId,
          clientId: this.loan.clientId,
          billNumber: this.invoiceForm.billNumber, 
          registerById: this.invoiceForm.sellerId,
          autoparts: this.loanDetails,
        };
        LoanService.updateLoan(this.$route.params.id, payload, this.$store);
        this.$swal("Éxito", "El préstamo y factura han sido guardados correctamente.", "success");
        this.showInvoiceModal = false;
        this.$router.push("/prestamo");
      } catch (error) {
        console.error("Error al guardar el préstamo con factura:", error);
        this.$swal("Error", "Ocurrió un problema al guardar el préstamo con factura.", "error");
      }
    },
    resetInvoiceForm() {
      this.invoiceForm.sellerId = null;
      this.invoiceForm.billNumber = "";
    },
    returnItem(item) {
      this.returnForm.qty = 1;
      this.returnForm.observation = "";
      this.returnForm.maxQty = item.qty;
      this.returnForm.item = item;
      this.showReturnModal = true;
    },
    confirmReturn() {
      if (!this.returnForm.observation) {
        this.$swal("Error", "La observación es obligatoria.", "error");
        return;
      }
      if (this.returnForm.qty > this.returnForm.maxQty) {
        this.$swal("Error", `La cantidad no puede exceder ${this.returnForm.maxQty}.`, "error");
        return;
      }

      this.$swal({
        title: "¿Estás seguro?",
        text: `Vas a devolver ${this.returnForm.qty} unidad(es).`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, devolver",
        cancelButtonText: "No, cancelar",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary mr-1",
          cancelButton: "btn btn-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const { qty, maxQty, item, observation } = this.returnForm;

          if (qty === maxQty) {
            item.state = "Devuelto";
            item.observation = observation; 
          } else {
            const remainingQty = maxQty - qty;
            const returnedItem = {
              ...item,
              qty: qty,
              state: "Devuelto",
              observation: observation,
            };

            item.qty = remainingQty;

            this.loanDetails.push(returnedItem);
          }

          this.$swal("Realizado", "Devolución realizada con éxito.", "success");
          this.showReturnModal = false;
        }
      });
    },

    resetReturnForm() {
      this.returnForm.qty = 1;
      this.returnForm.observation = "";
      this.returnForm.maxQty = 0;
      this.returnForm.item = null;
    },
  },
  computed: {
    sellerOptions() {
      return this.clients.map((client) => ({
        value: client.id,
        text: `${client.fullname} - (${client.document})`,
      }));
    },
  },
};
</script>

<style>
.modal-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
</style>